(() => {
  const labels = window.DVVCookieLabels || {};
  function enhanceBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.dvvStyled) return;
    const title = banner.querySelector('#shopify-pc__banner__body-title');
    const copy = banner.querySelector('.shopify-pc__banner__body p');
    const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!title || !copy || !accept) return;
    banner.dataset.dvvStyled = 'true';
    if (labels.title) title.textContent = labels.title;
    if (labels.copy) {
      const link = policy?.cloneNode(true);
      copy.textContent = labels.copy + ' ';
      if (link) copy.append(link);
    }
    if (labels.accept) accept.textContent = labels.accept;
    if (decline && labels.decline) decline.textContent = labels.decline;
    if (preferences && labels.preferences) preferences.textContent = labels.preferences;
  }
  new MutationObserver(enhanceBanner).observe(document.body, {childList: true, subtree: true});
  enhanceBanner();
  document.getElementById('dvv-cookie-settings')?.addEventListener('click', async function () {
    if (!window.privacyBanner) return;
    this.disabled = true;
    try {
      await (window.privacyBanner.showBanner || window.privacyBanner.showPreferences).call(window.privacyBanner);
      enhanceBanner();
    } finally { this.disabled = false; }
  });
})();
